<div class="row" style="background-color: #FFF; margin: 10px!important;">


  <div class="col-md-3 collapse show d-md-flex bg-light pt-2 pl-0 " id="sidebar"
       style="background-color: #FFF!important; padding: 30px!important; border-right: 2px solid #f8f9fc;">
    <ul class="nav flex-column flex-nowrap overflow-hidden menu_editar" style="font-size: 14px; color: #D9D9D9;">

      <li class="nav-item " [routerLinkActive]="['ativo_editar']">
        <a class="nav-link text-truncate" style="color: #A7A9C0;" [routerLink]="['/carteiras/editar']">
          <i class="fa fa-edit" style="font-size: 18px;"></i>
          <span class=" d-sm-inline" style="margin-left: 20px;">Editar Carteira</span>
          <i class=" fa fa-angle-right" style="font-size: 20px; margin-left: 30px;display: none;"></i>
        </a>
      </li>
      <li class="nav-item " [routerLinkActive]="['ativo_editar']">
        <a class="nav-link text-truncate" style="color: #A7A9C0;" [routerLink]="['/carteiras/editarp']">
          <i class="fa fa-rocket" aria-hidden="true" style="font-size: 18px;"></i>
          <span class=" d-sm-inline" style="margin-left: 20px;">Personalização</span>
          <i class=" fa fa-angle-right" style="font-size: 20px; margin-left: 30px;display: none;"></i>
        </a>
      </li>




    </ul>
  </div>


  <div class="col-md-9" style="padding: 30px;">


    <h2 style="color: #33343E; font-weight: normal;"> Personalizar Carteira</h2>
    <div class="text-center">
      <div class="card-body" style="position: relative;">

        <label class="hoverable" for="fileInput">
          <img src="{{editarConta.avatar}}" class="rounded-circle " style="width: 120px; height: 120px; border: 2px solid #f07335;" alt="Card image">
          <div class="hover-text" style="margin-left: 10px;"> <i class="fa fa-edit" style="font-size: 35px; color: #FFF;  "></i></div>
          <div class="background"></div>
        </label>


        <div style="background-color: #f07335; padding: 10px;
                  border-radius: 20px; width: 40px; position: absolute; margin-left: 50%; top: 60%; " (change)="onSelectFile( $event )">
          <i class="fa fa-edit" style="font-size: 18px; color: #FFF;  "></i>
          <input id="fileInput" type='file' >
        </div>

      </div>


    </div>
    <div class="form-group row">
      <div class="col-md-12 mb-3 mb-sm-0">
        <label for="site">WEBSITE</label>
        <input type="text" class="form-control form-control-user" name="site" id="site" [(ngModel)]="editarConta.site"
               placeholder="Nome">
      </div>

    </div>
    <div *ngIf="erro == 1" class="alert alert-danger" role="alert">
      O email já existe no banco de dados
    </div>
    <div class="form-group row">
      <div class="col-md-6">
        <label for="corPrimaria">COR PRIMÁRIA</label>
        <input type="email" class="form-control form-control-user demo"  [(colorPicker)]="editarConta.corPrimaria" [style.background]="editarConta.corPrimaria"  id="corPrimaria" name="corPrimaria" [(ngModel)]="editarConta.corPrimaria"
               placeholder="Email ">
      </div>
      <div class="col-md-6">
        <label for="corSecundaria">COR SECUNDÁRIA</label>
        <input type="text" class="form-control form-control-user demo" id="corSecundaria" [(ngModel)]="editarConta.corSecundaria" [(colorPicker)]="editarConta.corSecundaria" [style.background]="editarConta.corSecundaria"   name="corSecundaria"
               placeholder="Telefone ">
      </div>
    </div>



    <div class="form-group row">
      <div class="col-md-6 mb-3 mb-sm-0">
        <label for="versaoAppAndroid">Versão do Aplicativo Android</label>
        <input type="text" class="form-control form-control-user" [(ngModel)]="editarConta.versaoAppAndroid" name="versaoAppAndroid" id="versaoAppAndroid"
               placeholder="CEP">
      </div>
      <div class="col-md-6">
        <label for="versaoAppIos">Versão do Aplicativo IOS</label>
        <input type="text" class="form-control form-control-user" [(ngModel)]="editarConta.versaoAppIos" name="versaoAppIos" id="versaoAppIos"
               placeholder="CPF">
      </div>
    </div>



    <a class="btn btn-primary"  (click)="atualizarConta()" style="width: 200px; color: #FFF; height: 40px; background-color: #306C73;">Atualizar</a>
  </div>


</div>

